// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorAccounting = (client) => ({
    /**
     * `PUT /vendor/accounting/zoho-books/connect`
     *
     * @operationId VendorConnectZohoBooks
     * @source apps/backend/src/api/vendor/accounting/zoho-books/connect/route.ts
     */
    connectZohoBooks: (body, query, headers) => client.fetch("/vendor/accounting/zoho-books/connect", { method: "PUT", body, query, headers }),
    /**
     * `DELETE /vendor/accounting/tally`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDisconnectTally
     * @source apps/backend/src/api/vendor/accounting/tally/route.ts
     */
    deleteTally: (body, query, headers) => client.fetch("/vendor/accounting/tally", { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/accounting/zoho-books`
     *
     * @operationId VendorDisconnectZohoBooks
     * @source apps/backend/src/api/vendor/accounting/zoho-books/route.ts
     */
    disconnectZohoBooks: (body, query, headers) => client.fetch("/vendor/accounting/zoho-books", { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/accounting/zoho-books/contact-links`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetZohoBooksContactLinks
     * @source apps/backend/src/api/vendor/accounting/zoho-books/contact-links/route.ts
     */
    listZohoBooksContactLinks: (query, headers) => client.fetch("/vendor/accounting/zoho-books/contact-links", { method: "GET", query, headers }),
    /**
     * `GET /vendor/accounting/tally`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetTallyStatus
     * @source apps/backend/src/api/vendor/accounting/tally/route.ts
     */
    retrieveTally: (query, headers) => client.fetch("/vendor/accounting/tally", { method: "GET", query, headers }),
    /**
     * `GET /vendor/accounting/zoho-books`
     *
     * @operationId VendorGetZohoBooksStatus
     * @source apps/backend/src/api/vendor/accounting/zoho-books/route.ts
     */
    retrieveZohoBooksStatus: (query, headers) => client.fetch("/vendor/accounting/zoho-books", { method: "GET", query, headers }),
    /**
     * `PUT /vendor/accounting/tally/ledger-links`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPutTallyLedgerLink
     * @source apps/backend/src/api/vendor/accounting/tally/ledger-links/route.ts
     */
    updateTallyLedgerLink: (body, query, headers) => client.fetch("/vendor/accounting/tally/ledger-links", { method: "PUT", body, query, headers }),
    /**
     * `POST /vendor/accounting/tally/token`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorRotateTallyToken
     * @source apps/backend/src/api/vendor/accounting/tally/token/route.ts
     */
    updateTallyToken: (body, query, headers) => client.fetch("/vendor/accounting/tally/token", { method: "POST", body, query, headers }),
    /**
     * `PUT /vendor/accounting/zoho-books/contact-links`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPutZohoBooksContactLink
     * @source apps/backend/src/api/vendor/accounting/zoho-books/contact-links/route.ts
     */
    updateZohoBooksContactLink: (body, query, headers) => client.fetch("/vendor/accounting/zoho-books/contact-links", { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=accounting.js.map